import { Link } from 'react-router-dom';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';
import hashtag from '@assets/images/zaslouzisivic.svg';
import socialMediaDog from '@assets/images/social-media-dog.webp';



const Contact = (): JSX.Element => {

	return (
		<div className="app-page contact-page">
			
			<h1>Kontakt</h1>

			<div className='contact-address'>
				
				<p>VETlímce s.r.o.</p>
				
				<p>Cukrovarská 3006/20<br />
					Jižní Předměstí, 301&nbsp;00 Plzeň<br />
					<span>IČO:</span> 11979160<br />
					<span>DIČ:</span> CZ11979160</p>
			</div>

			<div className='contact-links'>
				<p><span>e-mail:</span> info@vetlimce.cz</p>
				<p><span>telefon:</span>+420 734 562 220</p>
				<p><span>web:</span> <Link to={'https://www.vetlimce.cz'} className='disable-selection'>www.vetlimce.cz</Link></p>
				<p><span>sociální sítě:</span></p>

				<div className='social-media-icons'>
					<Link to={'https://www.facebook.com/vetlimce'} className='disable-selection'>
						<img src={facebookIcon} alt='social-media-facebook' />
					</Link>

					<Link to={'https://www.instagram.com/vetlimce'} className='disable-selection'>
						<img src={instagramIcon} alt='social-media-instagram' />
					</Link>
				</div>
			</div>

			<div className='social-media-hashtag'>
				<img src={hashtag} alt='social-media-hashtag' />	
			</div>

			<div className='social-media-photo'>
				<img src={socialMediaDog} alt='social-media-photo' />	
			</div>

		</div>
	);
};

export default Contact;